import logger from "src/logger";
import LineItemII from "./LineItemII";
import compose from "recompose/compose";
import withProps from "recompose/withProps";
import withPropsOnChange from "recompose/withPropsOnChange";
import withHandlers from "recompose/withHandlers";
import withState from "recompose/withState";
import { rebuildAddonAndExtaEditUrl } from "../CartItems/LineItem/helpers";

import {
  getFormat,
  mergeAddons,
  getTitle,
  getType,
  getCustomisationString,
  getExpandedCustomisation,
  buildEditUrl,
  getAvailableGiftwraps,
  giftwrapCta,
  extrasCta,
} from "../CartItems/LineItem/helpers";
import {
  trackRemoved,
  trackEditAddons,
  trackEditItem,
  trackAddAddons,
} from "../../../analytics/category/cart";

import orderBy from "lodash/orderBy";
import withCountry from "../../hocs/withCountry";

const enhance = compose(
  withCountry,
  withState("giftwrapCta", "updateGiftwrapCta", (props) => giftwrapCta(props)),
  withState("availableAddons", "updateAvailableAddons", (props) =>
    getAvailableGiftwraps(props.item.itemAddonOptions)
  ),
  withState("extrasCta", "updateExtraCta", (props) => extrasCta(props)),
  withProps((props) => {
    return {
      productId: props.item.format.product.id,
      product: props.item.prismicProduct,
      fallbackProduct: props.item.fallbackPrismicProduct,
      productLocale: props.item.customisations.locale,
      lineItemPrefix:
        props.model.prismicGlobalContentModel.general.lineItemPrefix,
    };
  }),
  withHandlers({
    onRemove: (props) => () => {
      try {
        trackRemoved(props.item.format.product.id);
      } catch (error) {
        logger.error(error);
      }
      return props.handleRemove(props.item.id);
    },
    onEditItem: (props) => () => trackEditItem(props.item.format.product.id),
    onEditAddons: (props) => () =>
      trackEditAddons(props.item.format.product.id),
    onAddAddons: (props) => () => trackAddAddons(props.item.format.product.id),
  }),
  withProps((props) => {
    const addons =
      props.item.type !== "premade"
        ? orderBy(mergeAddons(props), ["type"], ["desc"])
        : [];

    let expandedCustomisation = getExpandedCustomisation(props, addons);
    expandedCustomisation =
      props.isCustomisationsExpanded && expandedCustomisation.length > 0
        ? expandedCustomisation
        : [];

    return {
      onClickLink: {
        editItem: props.onEditItem,
        editAddons: props.onEditAddons,
        addAddons: props.onAddAddons,
      },
      image: getFormat(props).image,
      title: getTitle(props),
      customisationString: getCustomisationString(props),
      expandedCustomisation,
      itemCustomisation: props.item.customisations,
      displayFormat: getType(props),
      type: props.item.type,
      addons,
      price: props.item.price,
      savings: props.item.savings,
      editUrl: buildEditUrl(props),
      editFormatUrl: buildEditUrl(props, "formats"),
      editExtrasUrl: buildEditUrl(props, "add-ons"),
      editGiftwrapUrl: buildEditUrl(props, "giftwraps"),
    };
  }),
  withPropsOnChange(["item"], (props) => {
    rebuildAddonAndExtaEditUrl(props);
    props.updateGiftwrapCta(giftwrapCta(props));
    props.updateAvailableAddons(
      getAvailableGiftwraps(props.item.itemAddonOptions)
    );
  })
);

export default enhance(LineItemII);
